module.exports = __webpack_public_path__ + "static/story4-index-thumbnails-1920x1080-0a178c609d1328c699abd5f2d218b780.jpg";